"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObject = void 0;
class IkeObject {
    /**
     * Copy Keys from src into dest omitting any null or undefined values
     *
     * @param dest the destination object to copy into
     * @param src the source object to copy from
     * @returns nothing as the destination object is updated.
     */
    static assignNotNull(dest, src) {
        for (const key of Object.keys(src)) {
            const value = src[key];
            if (value == null) {
                continue;
            }
            dest[key] = value;
        }
    }
}
exports.IkeObject = IkeObject;
//# sourceMappingURL=object.js.map